import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { css, styled } from '../../core/theme/styled';

export const BleedingBox = styled(Box)`
  margin-left: -${({ theme }) => theme.sizes.normal};
  margin-right: -${({ theme }) => theme.sizes.normal};
`;

export const ImageWrapper = styled(Box)`
  line-height: 0;
  margin-top: -${({ theme }) => theme.sizes.medium};
`;

export type ColorBarProps = {
  color: string;
};

export const ColorBar = styled.div<ColorBarProps>`
  background-color: ${({ color }) => color};
  height: ${({ theme }) => theme.sizes.large};
`;

export const CircularLogo = styled.img.attrs({ role: 'presentation' })<{
  diameter?: number;
  border?: boolean;
}>`
  width: ${({ diameter = 48 }) => `${diameter}px`};
  height: ${({ diameter = 48 }) => `${diameter}px`};
  object-fit: contain;
  ${({ border }) =>
    border &&
    css`
      border: 1px solid ${(props) => props.theme.configuration.backgroundColor};
      border-radius: 50%;
    `}
`;
